<template lang="pug">
  IconBase(:color="color" :size="size")
    include ../../../../../assets/images/icon/close.svg
</template>

<script>
  import IconBase from './IconBase'

  export default {
    name: 'IconClose',
    components: {
      IconBase
    },
    props: {
      color: {
        type: String,
        required: false,
        default: ''
      },
      size: {
        type: Number,
        required: false,
        default: 16
      }
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
</style>
